import React from 'react';

import { AgentReportCardPage } from './AgentReportCardPage';

/**
 * Monthly Sale Report (report #4) - 1:1 with the legacy monthlysalereport.aspx,
 * which renders the identical User | Current Month | Q1-4TD | YTD pivot as the
 * Agent Report Card but scoped to retail (non-corporate) bookings and grouped
 * per user. We reuse the Agent Report Card pivot with that configuration rather
 * than duplicate the ~500-line grid: retail-only, defaults to Consolidated User,
 * and drops the product-category table the legacy report does not show.
 */
export const MonthlySaleReportPage = (): React.JSX.Element => (
  <AgentReportCardPage
    title="Monthly Sale Report"
    description="Per-user monthly sale + profit for one financial year (retail bookings), with quarter and year-to-date rollups."
    exportName="monthly-sale-report"
    retailOnly
    defaultAgentSel="CONSOLIDATED_USER"
    showCategoryTable={false}
  />
);
